import { createContext, useContext, useEffect, useState } from "react";



export const MyThemeContext = createContext({
    theme: {
        mode: localStorage.getItem("mode")? localStorage.getItem("mode") : "dark"
    },
    setTheme: () => {}
});

export const ThemeContextProvider = ({ children }) => {
    const [theme, setTheme] = useState({
        mode: localStorage.getItem("mode")? localStorage.getItem("mode") : "dark"
    });

    const toggleTheme = mode => {
        if (localStorage.getItem("mode") === mode) {
            return;
        }
        setTheme(prev => {
            localStorage.setItem("mode", mode);
            return {
                ...prev,
                mode: mode
            }
        });
    }

    return (
        <MyThemeContext.Provider
            value={{
                theme,
                setTheme,
                toggleTheme
            }}
        >
            {children}
        </MyThemeContext.Provider>
    );
}

export const useThemeContext = () => {
    return useContext(MyThemeContext);
}

